<template>
  <CurrentIcon v-if="CurrentIcon" :rotate="props.rotate" :spin="props.spin" />
  <template v-else />
</template>

<script setup lang="ts">
import {
  AimOutlined,
  AppstoreOutlined,
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  AuditOutlined,
  BankOutlined,
  BarsOutlined,
  BellOutlined,
  CameraOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  CodeOutlined,
  CompassOutlined,
  CopyOutlined,
  DeleteOutlined,
  DesktopOutlined,
  DollarOutlined,
  EditFilled,
  EditOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilterOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  GlobalOutlined,
  HeatMapOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  InfoOutlined,
  LoadingOutlined,
  LockOutlined,
  LoginOutlined,
  LogoutOutlined,
  MenuOutlined,
  MinusOutlined,
  MoreOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  SearchOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  SnippetsOutlined,
  StarOutlined,
  StopOutlined,
  SyncOutlined,
  UndoOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons-vue';

import {EAntIconUrl} from './enums';

const icons = {
  [EAntIconUrl.AIM_OUTLINED]: AimOutlined,
  [EAntIconUrl.APPSTORE_OUTLINED]: AppstoreOutlined,
  [EAntIconUrl.ARROW_DOWN_OUTLINED]: ArrowDownOutlined,
  [EAntIconUrl.ARROW_LEFT_OUTLINED]: ArrowLeftOutlined,
  [EAntIconUrl.ARROW_RIGHT_OUTLINED]: ArrowRightOutlined,
  [EAntIconUrl.ARROW_UP_OUTLINED]: ArrowUpOutlined,
  [EAntIconUrl.AUDIT_OUTLINED]: AuditOutlined,
  [EAntIconUrl.BANK_OUTLINED]: BankOutlined,
  [EAntIconUrl.BARS_OUTLINED]: BarsOutlined,
  [EAntIconUrl.BELL_OUTLINED]: BellOutlined,
  [EAntIconUrl.CLOSE_CIRCLE_OUTLINED]: CloseCircleOutlined,
  [EAntIconUrl.CLOSE_OUTLINED]: CloseOutlined,
  [EAntIconUrl.CODE_OUTLINED]: CodeOutlined,
  [EAntIconUrl.COMPASS_OUTLINED]: CompassOutlined,
  [EAntIconUrl.COPY_OUTLINED]: CopyOutlined,
  [EAntIconUrl.PLUS_CIRCLE_OUTLINED]: PlusCircleOutlined,
  [EAntIconUrl.PLUS_OUTLINED]: PlusOutlined,
  [EAntIconUrl.EDIT_OUTLINED]: EditOutlined,
  [EAntIconUrl.EDIT_FILLED]: EditFilled,
  [EAntIconUrl.DELETE_OUTLINED]: DeleteOutlined,
  [EAntIconUrl.DOLLAR_OUTLINED]: DollarOutlined,
  [EAntIconUrl.FILE_OUTLINED]: FileOutlined,
  [EAntIconUrl.FILE_PDF_OUTLINED]: FilePdfOutlined,
  [EAntIconUrl.FILTER_OUTLINED]: FilterOutlined,
  [EAntIconUrl.FOLDER_OPEN_OUTLINED]: FolderOpenOutlined,
  [EAntIconUrl.FOLDER_OUTLINED]: FolderOutlined,
  [EAntIconUrl.HOME_OUTLINED]: HomeOutlined,
  [EAntIconUrl.GLOBAL_OUTLINED]: GlobalOutlined,
  [EAntIconUrl.HEAT_MAP_OUTLINED]: HeatMapOutlined,
  [EAntIconUrl.INFO_OUTLINED]: InfoOutlined,
  [EAntIconUrl.INFO_CIRCLE_OUTLINED]: InfoCircleOutlined,
  [EAntIconUrl.LOADING_OUTLINED]: LoadingOutlined,
  [EAntIconUrl.LOCK_OUTLINED]: LockOutlined,
  [EAntIconUrl.LOGOUT_OUTLINED]: LogoutOutlined,
  [EAntIconUrl.LOGIN_OUTLINED]: LoginOutlined,
  [EAntIconUrl.MENU_OUTLINED]: MenuOutlined,
  [EAntIconUrl.MINUS_OUTLINED]: MinusOutlined,
  [EAntIconUrl.MORE_OUTLINED]: MoreOutlined,
  [EAntIconUrl.SHOP_OUTLINED]: ShopOutlined,
  [EAntIconUrl.SHOPPING_CART_OUTLINED]: ShoppingCartOutlined,
  [EAntIconUrl.SNIPPETS_OUTLINED]: SnippetsOutlined,
  [EAntIconUrl.STAR_OUTLINED]: StarOutlined,
  [EAntIconUrl.STOP_OUTLINED]: StopOutlined,
  [EAntIconUrl.SEARCH_OUTLINED]: SearchOutlined,
  [EAntIconUrl.SYNC_OUTLINED]: SyncOutlined,
  [EAntIconUrl.UNDO_OUTLINED]: UndoOutlined,
  [EAntIconUrl.USER_OUTLINED]: UserOutlined,
  [EAntIconUrl.VIDEO_CAMERA_OUTLINED]: VideoCameraOutlined,
  [EAntIconUrl.DESKTOP_OUTLINED]: DesktopOutlined,
  [EAntIconUrl.CAMERA_OUTLINED]: CameraOutlined,
};

interface IProps {
  url?: EAntIconUrl;

  rotate?: number;
  spin?: boolean;
}

const props = defineProps<IProps>();

const CurrentIcon = props.url != undefined ? icons[props.url] : undefined;
</script>

<style lang="scss" />
